var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
const exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
const get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
const eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
const findLatestVersion = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
const findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
const findSingletonVersionKey = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
const getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
const getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	const versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
const fail = (msg) => {
	throw new Error(msg);
}
const failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
const warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
const init = (fn) => (function(scopeName, key, eager, c, d) {
	const promise = __webpack_require__.I(scopeName);
	if (promise?.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

const useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
const load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
const loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
const loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
const loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
const loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const installedModules = {};
const moduleToHandlerMapping = {
	97656: () => (loadSingletonVersion("default", "react", false, [1,18,0,0], () => (Promise.all([__webpack_require__.e(7614), __webpack_require__.e(5342), __webpack_require__.e(2913), __webpack_require__.e(3928), __webpack_require__.e(7254), __webpack_require__.e(365), __webpack_require__.e(359), __webpack_require__.e(6383), __webpack_require__.e(6201), __webpack_require__.e(9612), __webpack_require__.e(3025), __webpack_require__.e(4400), __webpack_require__.e(4744), __webpack_require__.e(5077), __webpack_require__.e(6876), __webpack_require__.e(7168), __webpack_require__.e(9354), __webpack_require__.e(3423), __webpack_require__.e(9779), __webpack_require__.e(4977), __webpack_require__.e(9892), __webpack_require__.e(1314), __webpack_require__.e(7946), __webpack_require__.e(5542), __webpack_require__.e(166), __webpack_require__.e(2573), __webpack_require__.e(6347), __webpack_require__.e(5298), __webpack_require__.e(8688), __webpack_require__.e(2064), __webpack_require__.e(8416), __webpack_require__.e(6578), __webpack_require__.e(497), __webpack_require__.e(9855), __webpack_require__.e(6494), __webpack_require__.e(4584), __webpack_require__.e(9422), __webpack_require__.e(1048), __webpack_require__.e(315), __webpack_require__.e(5894), __webpack_require__.e(9198), __webpack_require__.e(6860), __webpack_require__.e(3588), __webpack_require__.e(4448), __webpack_require__.e(2131), __webpack_require__.e(3256), __webpack_require__.e(4671), __webpack_require__.e(1669), __webpack_require__.e(9554), __webpack_require__.e(320), __webpack_require__.e(734), __webpack_require__.e(5639), __webpack_require__.e(8000), __webpack_require__.e(4290), __webpack_require__.e(8191), __webpack_require__.e(145), __webpack_require__.e(2870), __webpack_require__.e(236), __webpack_require__.e(1098), __webpack_require__.e(4675), __webpack_require__.e(73), __webpack_require__.e(2239), __webpack_require__.e(4321), __webpack_require__.e(1680), __webpack_require__.e(9717), __webpack_require__.e(6131), __webpack_require__.e(9159), __webpack_require__.e(5434), __webpack_require__.e(69), __webpack_require__.e(9658), __webpack_require__.e(7098), __webpack_require__.e(2640), __webpack_require__.e(7004), __webpack_require__.e(5904), __webpack_require__.e(718), __webpack_require__.e(4919), __webpack_require__.e(3773), __webpack_require__.e(9916), __webpack_require__.e(5144)]).then(() => (() => (__webpack_require__(77810))))))),
	25686: () => (loadSingletonVersion("default", "react-dom", false, [1,18,0,0], () => (Promise.all([__webpack_require__.e(7614), __webpack_require__.e(5342), __webpack_require__.e(2913), __webpack_require__.e(3928), __webpack_require__.e(7254), __webpack_require__.e(365), __webpack_require__.e(359), __webpack_require__.e(6383), __webpack_require__.e(6201), __webpack_require__.e(9612), __webpack_require__.e(3025), __webpack_require__.e(4400), __webpack_require__.e(4744), __webpack_require__.e(5077), __webpack_require__.e(6876), __webpack_require__.e(7168), __webpack_require__.e(9354), __webpack_require__.e(3423), __webpack_require__.e(9779), __webpack_require__.e(4977), __webpack_require__.e(9892), __webpack_require__.e(1314), __webpack_require__.e(7946), __webpack_require__.e(5542), __webpack_require__.e(166), __webpack_require__.e(2573), __webpack_require__.e(6347), __webpack_require__.e(5298), __webpack_require__.e(8688), __webpack_require__.e(2064), __webpack_require__.e(8416), __webpack_require__.e(6578), __webpack_require__.e(497), __webpack_require__.e(9855), __webpack_require__.e(6494), __webpack_require__.e(4584), __webpack_require__.e(9422), __webpack_require__.e(1048), __webpack_require__.e(315), __webpack_require__.e(5894), __webpack_require__.e(9198), __webpack_require__.e(6860), __webpack_require__.e(3588), __webpack_require__.e(4448), __webpack_require__.e(2131), __webpack_require__.e(3256), __webpack_require__.e(4671), __webpack_require__.e(1669), __webpack_require__.e(9554), __webpack_require__.e(320), __webpack_require__.e(734), __webpack_require__.e(5639), __webpack_require__.e(8000), __webpack_require__.e(4290), __webpack_require__.e(8191), __webpack_require__.e(145), __webpack_require__.e(2870), __webpack_require__.e(236), __webpack_require__.e(1098), __webpack_require__.e(4675), __webpack_require__.e(73), __webpack_require__.e(2239), __webpack_require__.e(4321), __webpack_require__.e(1680), __webpack_require__.e(9717), __webpack_require__.e(6131), __webpack_require__.e(9159), __webpack_require__.e(5434), __webpack_require__.e(69), __webpack_require__.e(9658), __webpack_require__.e(7098), __webpack_require__.e(2640), __webpack_require__.e(7004), __webpack_require__.e(5904), __webpack_require__.e(718), __webpack_require__.e(4919), __webpack_require__.e(3773), __webpack_require__.e(9916), __webpack_require__.e(5144)]).then(() => (() => (__webpack_require__(22483)))))))
};
// no consumes in initial chunks
const chunkMapping = {
	"5686": [
		25686
	],
	"7656": [
		97656
	]
};
const startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			const onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			const onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				const promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}